import React, { useMemo } from "react";
import { useApiData } from "../../hooks/useFetch.js";
import { api } from "../../api/api.js";
import StateGuard from "../StateGuard.jsx";
import MargeChart from "../charts/MargeChart.jsx";

export default function MargeTab({
  baseParams,
  prixVente,
  fraisCultureHorsIrrigation,
  equipement,
  selectedEquipParams,
  lissage,
  parHa,
  typeMarge,
  prixEauList,
  prixElecList,
  culture,
  libelle,
}) {
  const params = useMemo(
    () => ({
      ...baseParams,
      prix_vente: prixVente,
      frais_culture_hors_irrigation: fraisCultureHorsIrrigation,
      equipement,
      conso: selectedEquipParams?.conso,
      investissement: selectedEquipParams?.investissement,
      duree_vie: selectedEquipParams?.duree_vie,
      entretien: selectedEquipParams?.entretien,
      efficite: selectedEquipParams?.efficite,
      main_doeuvre: selectedEquipParams?.main_doeuvre,
      lissage,
      par_ha: parHa,
      prix_eau: prixEauList,
      prix_elec: prixElecList,
    }),
    [baseParams, prixVente, fraisCultureHorsIrrigation, equipement, selectedEquipParams, lissage, parHa, prixEauList, prixElecList]
  );

  const { data, loading, error } = useApiData(api.getMarge, params, {
    skip: !baseParams.idProdu || !baseParams.gridno,
  });

  return (
    <div className="diagoeau-panel">
      <h3>
        Marge {typeMarge === "cumul" ? "cumulée" : "annuelle"} — {culture} | {libelle}
        {parHa ? " | par hectare" : ""} | prix {prixVente} €/t
      </h3>
      <StateGuard
        loading={loading}
        error={error}
        empty={!data || data.length === 0}
        emptyMessage="Pas de données pour cette région / scénario."
      >
        {data && <MargeChart data={data} typeMarge={typeMarge} />}
      </StateGuard>
    </div>
  );
}